export const categories = [
  { value: 'Acupuncture', label: 'Acupuncture', requiresCertification: true },
  { value: 'Aromatherapy', label: 'Aromatherapy', requiresCertification: true },
  { value: 'Astrology', label: 'Astrology', requiresCertification: false },
  { value: 'Ayurveda', label: 'Ayurveda', requiresCertification: true },
  { value: 'Birth_Doula', label: 'Birth Doula', requiresCertification: true },
  { value: 'Breathwork', label: 'Breathwork', requiresCertification: true },
  { value: 'Chiropractor', label: 'Chiropractor', requiresCertification: true },
  { value: 'Content_Creator', label: 'Content Creator', requiresCertification: false },
  { value: 'Couples_Counselling', label: 'Couples Counselling', requiresCertification: true },
  { value: 'Craniosacral_Therapy', label: 'Craniosacral Therapy', requiresCertification: true },
  { value: 'EMDR_Therapy', label: 'EMDR Therapy', requiresCertification: true },
  { value: 'Forager', label: 'Forager', requiresCertification: false },
  { value: 'Gut_Health_Specialist', label: 'Gut Health Specialist', requiresCertification: true },
  { value: 'Healthy_Retreat_Chef', label: 'Healthy Retreat Chef', requiresCertification: false },
  { value: 'Heart_Coherence', label: 'Heart Coherence', requiresCertification: true },
  { value: 'Herbalism', label: 'Herbalism', requiresCertification: true },
  { value: 'Hypnotherapy', label: 'Hypnotherapy', requiresCertification: true },
  { value: 'Ice_Bath_Facilitator', label: 'Ice Bath Facilitator', requiresCertification: true },
  { value: 'Life_Coach', label: 'Life Coach', requiresCertification: true },
  { value: 'Lymphatic_Drainage', label: 'Lymphatic Drainage', requiresCertification: true },
  { value: 'Massage_Therapy', label: 'Massage Therapy', requiresCertification: true },
  { value: 'Meditation', label: 'Meditation', requiresCertification: true },
  { value: 'Nutrition', label: 'Nutrition', requiresCertification: true },
  { value: 'Permaculture_Designer', label: 'Permaculture Designer', requiresCertification: false },
  { value: 'Personal_Training', label: 'Personal Training', requiresCertification: true },
  { value: 'Photography', label: 'Photography', requiresCertification: false },
  { value: 'Pilates', label: 'Pilates', requiresCertification: true },
  { value: 'Pregnancy', label: 'Pregnancy', requiresCertification: true },
  { value: 'Psychedelic_Therapy', label: 'Psychedelic Therapy', requiresCertification: true },
  { value: 'Psychotherapy', label: 'Psychotherapy', requiresCertification: true },
  { value: 'Qigong', label: 'QiQong', requiresCertification: true },
  { value: 'Quantum_Healing', label: 'Quantum Healing', requiresCertification: true },
  { value: 'Reflexology', label: 'Reflexology', requiresCertification: true },
  { value: 'Reiki', label: 'Reiki', requiresCertification: true },
  { value: 'Sex_Therapy', label: 'Sex Therapy', requiresCertification: true },
  { value: 'Shamanic_Journeying', label: 'Shamanic Journeying', requiresCertification: true },
  { value: 'Singing', label: 'Singing', requiresCertification: true },
  { value: 'Somatic_Experiencing', label: 'Somatic Experiencing', requiresCertification: true },
  { value: 'Sound_Healing', label: 'Sound Healing', requiresCertification: true },
  { value: 'Tai_Chi', label: 'Tai Chi', requiresCertification: true },
  { value: 'TRE', label: 'TRE (Trauma Release Exercises)', requiresCertification: true },
  { value: 'Yoga', label: 'Yoga Teacher', requiresCertification: true }
];